<app-traitement-data titre="O2 repos" [sousTitre]="patient!.tableauDeBord?.debit02Repos?.date | aLaDateDu"
    [statut]="patient!.tableauDeBord?.debit02Repos?.value ? 'info' : 'warning'">
    {{ patient!.tableauDeBord?.debit02Repos?.value ?? 'Pas de donnée' }}
</app-traitement-data>